export const previewImageVersion = 'v2';
